import { Pole_t } from "../types/pole";

export interface ItemsTechno {
  title: string;

  picture_url?: string;
  bgColor?: string;

  size?: string;
  height?: string;

  icon?: string;
  iconColor?: string;

  subItems?: Pole_t[];
  href?: string;
}

const Technologie = {
  title: "Technologie",
  href: "auth/pole/competences",

  picture_url:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/image-techno-formace(1)(1).jpg",
  bgColor: "rgba( 255,162,31, 0.55)",

  subItems: [
    { name: "Pole 1", value: 1 },
    { name: "Pole 2", value: 2 },
  ],
};

const Pratique = {
  title: "Pratique",
  href: "auth/pole/generiques",

  picture_url:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Lapin+saut%C3%A9+chasseur.00_04_15_11.Still002.jpg",
  bgColor: "rgba( 255,162,31, 0.55)",

  subItems: [
    { name: "Boutique", value: 1 },
    { name: "Fraîche Découpe", value: 2 },
  ],
};

const PratiqueChar = {
  title:
    " Pôle 1: Préparation et réalisation de la production, activité professionnelle de fabrication.",
  href: "auth/pole/generiques",

  picture_url:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Lapin+saut%C3%A9+chasseur.00_04_15_11.Still002.jpg",
  bgColor: "rgba( 255,162,31, 0.55)",

  subItems: [
    { name: "Boutique", value: 1 },
    { name: "Fraîche Découpe", value: 2 },
  ],
};

const Tutoriels = {
  title: "Tutoriels vidéos pas à pas",
  href: "auth/pole/generiques",

  picture_url:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/BOUL-tuto.jpg",
  bgColor: "rgba( 255,162,31, 0.36)",

  subItems: [
    { name: "Pole 1", value: 1 },
    { name: "Pole 2", value: 2 },
  ],
};

const TP_TD = {
  title: "Travaux pratiques et dirigés",
  picture_url:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/BOUL-tptd1.jpg",
  bgColor: "rgba( 255,162,31, 0.22)",
  href: "auth/workaside",
  subItems: [
    { name: "Travaux Pratiques", value: "?type=tp" },
    { name: "Travaux Dirigés", value: "?type=td" },
  ],
};
const TP_TD_boul = {
  title: "Travaux pratiques et dirigés",
  picture_url:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/BOUL-tptd1.jpg",
  bgColor: "rgba( 255,162,31, 0.22)",
  href: "auth/workaside",
  subItems: [
    { name: "Replay", value: "?type=tp", disabled: true },
    { name: "Travaux Dirigés", value: "?type=td" },
  ],
};

const PSE = {
  title: "PSE",
  href: "auth/book?type=pse",
  picture_url:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/PSE.png",
  size: "6",
  bgColor: "rgba( 222,49,99, 0.20)",
};

const PRATICAL_BOOK = {
  title: "Fiches techniques à trou + quiz de compétence",
  href: "auth/formalPratique",
  picture_url:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Capture+d%E2%80%99%C3%A9cran+du+2023-08-22+12-27-20.png",
  size: "6",
  bgColor: "rgba( 222,49,99, 0.20)",
};

const SyntheseBook = {
  title: "Livre de synthese",
  href: "auth/book?type=synthese",

  bgColor: "rgba(222,49,99, 0.15)",
  height: "0.5",
  icon: "https://cdn-icons-png.flaticon.com/512/2702/2702134.png",
  iconColor: "black",
};

const TechnologieBook = {
  title: "Livre de technologie",
  bgColor: "rgba(222,49,99, 0.15)",
  icon: "https://cdn-icons-png.flaticon.com/512/2702/2702134.png",
  iconColor: "black",
  height: "0.5",
  href: "auth/book?type=techno",
};

const ScienceBook = {
  title: "Livre de Sciences appliquées",
  bgColor: "rgba(222,49,99, 0.15)",
  icon: "https://cdn-icons-png.flaticon.com/512/2702/2702134.png",
  iconColor: "black",
  height: "0.5",
  size: "12",
  href: "auth/book?type=sciencesappliquees",
};

const GestionBook = {
  title: "Livre de Gestion appliquée",
  bgColor: "rgba(222,49,99, 0.15)",
  icon: "https://cdn-icons-png.flaticon.com/512/2702/2702134.png",
  iconColor: "black",
  height: "0.5",
  size: "12",
  href: "auth/book?type=gestionsappliquees",
};

const Replay = {
  title: "Replay",
  size: "6",
  picture_url:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Replay.jpg",
  bgColor: "rgba( 255,162,31, 0.22)",
  href: "auth/replay",
  subItems: [
    { name: "Travaux Pratiques", value: "?type=pratique" },
    { name: "Technologie", value: "?type=techno" },
  ],
};

const Feed = {
  title: "Mur social",
  size: process.env.REACT_APP_NAME === "DELICEO" ? "12" : "6",
  href: "auth/feed",
  picture_url:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Mur+social+2.jpg",
  bgColor: "rgba(222,49,99,0.060)",
};

export const boulItems: Array<ItemsTechno | ItemsTechno[]> = [
  {
    ...Technologie,
    title: "Savoirs associés",
    subItems: [{ name: "Accès aux savoirs associés", value: 1 }],
  },
  {
    ...Tutoriels,
    subItems: [{ name: "Accès aux tutoriels vidéos", value: 1 }],
  },
  TP_TD_boul,
  PSE,
  process.env.REACT_APP_NAME === "DELICEO"
    ? [TechnologieBook]
    : [TechnologieBook, SyntheseBook],
  ScienceBook,
  GestionBook,
  ...(process.env.REACT_APP_NAME === "DELICEO" ? [] : [Replay]),
  Feed,
];

export const patItems: Array<ItemsTechno | ItemsTechno[]> = [
  Technologie,
  {
    ...Tutoriels,
    picture_url:
      "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/PAT-tuto.jpg",
  },
  {
    ...TP_TD,
    picture_url:
      "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/PAT-tptd.jpg",
  },
  PSE,
  process.env.REACT_APP_NAME === "DELICEO"
    ? [TechnologieBook]
    : [SyntheseBook, TechnologieBook],
  ...(process.env.REACT_APP_NAME === "DELICEO" ? [] : [Replay]),
  Feed,
];

export const primItems: Array<ItemsTechno | ItemsTechno[]> = [
  Technologie,
  {
    ...Pratique,
    picture_url:
      "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Corbeille+-mains-UNE.jpg",
    title: "Pratique",
    subItems: [
      { ...Tutoriels.subItems[0], name: "Boutique" },
      { ...Tutoriels.subItems[1], name: "Fraîche découpe" },
    ],
  },
  { ...TechnologieBook, size: "6", height: "1" },
  Feed,
];

export const cuisineItems: Array<ItemsTechno | ItemsTechno[]> = [
  Technologie,
  {
    ...Tutoriels,
    title: "Tutoriel vidéo",
    subItems: [{ ...Tutoriels.subItems[0], name: "Pole 1" }],
    picture_url:
      "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/PAT-tuto.jpg",
  },
  { ...TechnologieBook, size: "6", height: "1" },
  PSE,
  Feed,
];

export const charItems: Array<ItemsTechno | ItemsTechno[]> = [
  {
    ...PratiqueChar,
    href: "/auth/pole/generiques",
    subItems: [
      {
        name: " Activité 1: préparation de la production/Activité 2: fabrication",
        value: 1,
      },
    ],
  },
  {
    ...Technologie,
    title:
      "Savoir associé pôle 2 : organisation et sécurisation de la production",
    subItems: [
      {
        name: "Activité professionnelle 3/ Activité professionnelle 4",
        value: 1,
      },
    ],
  },

  [
    {
      ...TechnologieBook,
      title: TechnologieBook.title + " (T1)",
      href: "auth/book?type=annee1",
    },
    {
      ...TechnologieBook,
      title: TechnologieBook.title + " (T2)",
      href: "auth/book?type=annee2",
    },
  ],
  { ...ScienceBook, size: "6", height: "1" },
  { ...PSE, size: "12" },
  { ...PRATICAL_BOOK, size: "12" },
  { ...Feed, size: "12" },
];
